
import React, { useState, useMemo, useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import axios from "axios";
// import Loader from './components/Loader';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { themeOption } from '../theme';
import ResponsiveAppBar from "./components/Header";
import appRoutes from "../App/routes";
import { StoreProvider } from './store/Store';

import storageKeys from './constants/storageKeys';
import { AppProvider, AuthProvider, GlobalProvider, FirestoreDataProvider, BookingsProvider } from "../context";
import { ErrorBoundary } from "./ErrorBoundary";
import { ReactQueryProvider } from "./ReactQueryProvider";
import { NetworkBanner } from "./components/NetworkBanner";
import "./styles.css";

export default function App() {
  // const navigate = useNavigate();
  const [mode, setMode] = useState("light");
  const [state, setState] = useState({
    ip: "",
    countryName: "",
    countryCode: "",
    city: "",
    timezone: "",
    slug: ""
  });

  const theme = useMemo(() => themeOption(mode), [mode]);

  const getGeoInfo = () => {
    axios
      .get("https://ipapi.co/json/")
      .then((response) => {
        let data = response.data;
        localStorage.setItem(storageKeys.VKCH_IP_DATA, JSON.stringify(data));
        setState({
          ip: data.ip,
          countryName: data.country_name,
          countryCode: data.country_calling_code,
          city: data.city,
          timezone: data.timezone,
          latitude: data.latitude,
          longitude: data.longitude,
          slug: `${data.city.toLowerCase()}-${data.country_name.toLowerCase()}`
        });
        // navigate(`/${data.city.toLowerCase()}-${data.country_name.toLowerCase()}`);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (!state.ip) getGeoInfo();
    // Once, on mount. `state.ip` starts empty, so listing it would re-run this
    // the moment the lookup resolves, and `getGeoInfo` is rebuilt every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!appRoutes(state)) return null;
  

  return (
    <ErrorBoundary>
      <ReactQueryProvider>
        <FirestoreDataProvider>
          <BookingsProvider>
            <GlobalProvider>
              <ThemeProvider theme={theme}>
                <CssBaseline enableColorScheme />
                <AuthProvider>
                  <AppProvider>
                    <StoreProvider>
                      <NetworkBanner />
                      <ResponsiveAppBar mode={mode} onChange={() => setMode(mode === "light" ? "dark" : "light")} />
                      <AnimatePresence mode="wait" initial={false}>
                        {appRoutes(state)}
                        {/* <Footer /> */}
                      </AnimatePresence>
                    </StoreProvider>
                  </AppProvider>
                 </AuthProvider>
              </ThemeProvider>
            </GlobalProvider>
          </BookingsProvider>
        </FirestoreDataProvider>
      </ReactQueryProvider>
    </ErrorBoundary>
  );
}
